import { useMemo, useState } from 'react';

export default function SearchableMemberChecklist({
  members = [],
  selectedIds = [],
  onChange,
  maxSelected,
  className = 'max-h-40 overflow-y-auto border rounded p-2 space-y-1 bg-white',
  itemClassName = 'flex items-center gap-2 text-sm cursor-pointer',
  placeholder = 'Search people…',
  showTeam = false
}) {
  const [query, setQuery] = useState('');
  const selected = selectedIds.map(String);
  const selectedSet = useMemo(() => new Set(selected), [selected]);
  const cap = Number.isFinite(maxSelected) && maxSelected > 0 ? maxSelected : Infinity;

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return members;
    return members.filter((m) => {
      const name = String(m.name || '').toLowerCase();
      const team = String(m.team || '').toLowerCase();
      return name.includes(q) || (showTeam && team.includes(q));
    });
  }, [members, query, showTeam]);

  const toggle = (id, checked) => {
    const key = String(id);
    if (checked) {
      if (selectedSet.has(key) || selected.length >= cap) return;
      onChange([...selected, key]);
    } else {
      onChange(selected.filter((value) => value !== key));
    }
  };

  return (
    <div>
      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        className="border rounded w-full px-3 py-2 text-sm mb-2 bg-white"
        aria-label={placeholder}
      />
      <div className={className}>
        {filtered.length === 0 ? (
          <p className="text-xs text-gray-500 py-1">No matching people</p>
        ) : (
          filtered.map((m) => (
            <label key={m.id} className={itemClassName}>
              <input
                type="checkbox"
                checked={selectedSet.has(String(m.id))}
                onChange={(e) => toggle(m.id, e.target.checked)}
              />
              <span>{m.name}</span>
              {showTeam && m.team && (
                <span className="text-xs text-gray-500">({m.team})</span>
              )}
            </label>
          ))
        )}
      </div>
    </div>
  );
}
